import { render, staticRenderFns } from "./signForm2.vue?vue&type=template&id=1621601a&scoped=true&"
import script from "./signForm2.vue?vue&type=script&lang=js&"
export * from "./signForm2.vue?vue&type=script&lang=js&"
import style0 from "./signForm2.vue?vue&type=style&index=0&id=1621601a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1621601a",
  null
  
)

export default component.exports